// One bounded policy for upload, import and the picker. Library scope remains
// the caller's HOME workspace/user, enforced by database predicates and locks.
export const stickerLimits = Object.freeze({
  packs: 100,
  libraryBytes: 256 * 1024 * 1024,
  packBytes: 32 * 1024 * 1024,
  stickersPerPack: 120,
  uploadBytes: 1024 * 1024,
  normalizedBytes: 256 * 1024,
});
